import { create } from "zustand";

import type { User } from "@/types";

// S-SEC-3 (finding #8) — tokens NO LONGER live in JS.
//
// Access + refresh tokens are stored exclusively in httpOnly cookies set
// by the API; the browser attaches them automatically and JS (including
// any XSS payload) cannot read them. This store therefore holds only the
// non-secret user identity, and only in memory — nothing is persisted to
// localStorage. On a full page reload the store is empty and the session
// is rehydrated by calling GET /api/v1/auth/me (the cookie authenticates
// that call). ``authChecked`` guards that initial rehydration so the UI
// doesn't flash the login page before the /me probe resolves.
interface AuthState {
  user: User | null;
  authChecked: boolean;
  setUser: (user: User | null) => void;
  setAuthChecked: (checked: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  authChecked: false,
  setUser: (user) => set({ user }),
  setAuthChecked: (authChecked) => set({ authChecked }),
  clear: () => set({ user: null }),
}));
